import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { products } from '../data/products';

const Products = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col space-y-16">
      {/* --- Hero bo‘limi --- */}
      <section
        className="relative h-64 md:h-96 bg-cover bg-center"
        style={{
          backgroundImage: "url('https://plus.unsplash.com/premium_photo-1682766346717-e9e8a9e339fe?q=80&w=1932&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')"
        }}
      >
        <div className="absolute inset-0 bg-black opacity-50" />
        <div className="relative container mx-auto h-full flex flex-col items-center justify-center text-center px-4">
          <h1 className="text-4xl md:text-5xl font-extrabold text-white drop-shadow-lg font-techno">
            {t('products.heroTitle', 'Mahsulotlar')}
          </h1>
          <p className="mt-2 text-lg md:text-xl text-gray-200 drop-shadow-md font-sans max-w-2xl">
            {t(
              'products.heroSubtitle',
              'Sifatli Onlayn kassa texnikalar bilan biznesingizni yangi bosqichga olib chiqing'
            )}
          </p>
        </div>
      </section>

      {/* --- Mahsulotlar ro‘yxati --- */}
      <section className="bg-gray-50 py-16">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-etmgreen text-center mb-8 font-techno">
            {t('products.listTitle', 'Mavjud Mahsulotlar')}
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {products.map((item) => (
              <Link
                to={`/products/${item.id}`}
                key={item.id}
                className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition flex flex-col"
              >
                <div className="w-full h-48 bg-gray-100 flex items-center justify-center overflow-hidden rounded-lg mb-4">
                  <img
                    src={item.img}
                    alt={item.name}
                    className="object-contain h-full"
                  />
                </div>
                <h3 className="text-xl font-semibold text-gray-800 mb-2 font-techno">
                  {item.name}
                </h3>
                <p className="text-gray-600 text-sm mb-4 flex-grow font-sans">
                  {item.desc.length > 80
                    ? item.desc.slice(0, 80) + '...'
                    : item.desc}
                </p>
                <button
                  type="button"
                  className="mt-auto bg-etmgreen text-white font-medium py-2 rounded-lg hover:bg-green-600 transition font-techno"
                >
                  {t('products.viewDetails', 'Batafsil')}
                </button>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Products;
